<template>
  <div>
    <h1>Male Celebrities Naked In Movies</h1>
    <p style="text-align: center;">Search Actors</p>
    <div class="search-wrapper">
      <input type="text" v-model="search" placeholder="Search actors.." />
      <label>Search model:</label>
    </div>
    <!-- 
    <div v-if="search && filteredGay.length > 0" class="search-box">
      <p style="text-align: center;">In Gay Scenes</p>
      <router-link
        v-for="video in filteredGay"
        :key="video.id"
        :to="{ name: 'gay-video', params: {id:video.id} }"
        class="search-item"
      >{{video.actor}} in "{{video.title}}"</router-link>
    </div>-->

    <!-- <div v-if="search && filteredNaked.length > 0" class="search-box">
      <p style="text-align: center;">In Naked Scenes</p>
      <router-link
        v-for="model in filteredNaked"
        :key="model.id"
        :to="{ name: 'naked-video', params: {id:model.id} }"
        class="search-item"
      >{{model.actor}} in "{{model.title}}"</router-link>
    </div>-->

    <div v-if="search && filteredActors.length > 0" class="search-box">
      <a
        v-for="actor in filteredActors"
        :key="actor.actor"
        :href="'https://www.malecinema.com/celebs/' + actor.actor.replace(/ /g,'-')+'.html'"
        class="search-item"
      >{{actor.actor}}</a>
    </div>

    <h3>Sections</h3>
    <div class="main-flex">
      <div class="grid-box">
        <router-link to="/naked/">
          <img
            title="male nudity in the cinema free"
            src="https://www.malecinema.com/banners/naked-main.jpg"
            alt="male celebrities naked videos"
            width="250"
            height="250"
          />
        </router-link>
        <router-link to="/naked/">
          Naked scenes
          <p style="text-align: center;">Over 1600 videos</p>
        </router-link>
      </div>

      <div class="grid-box">
        <router-link to="/gay/">
          <img
            title="male nudity in the cinema free"
            src="https://www.malecinema.com/banners/movies.jpg"
            alt="male celebrities gay sex scenes"
            width="250"
            height="250"
          />
        </router-link>
        <router-link to="/gay/">
          Gay scenes
          <p style="text-align: center;">Over 1100 videos</p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
// import gayJson from "@/az_final_gay.json";
// import nakedJson from "@/az_final_naked.json";

// let gayArray = JSON.parse(JSON.stringify(gayJson));
// let nakedArray = JSON.parse(JSON.stringify(nakedJson));

import rawActors from "@/nude-top040320.json";
let allActors = JSON.parse(JSON.stringify(rawActors));
export default {
  metaInfo() {
    return {
      title: "Male Celebrities - Naked In Movies - In Gay Sex Scenes",
      meta: [
        {
          name: "description",
          content:
            "Watch thouthands of videos with male celebrities getting naked in movies, showing their butts and cocks and also having gay sex."
        }
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.malecinema.com/movies/"
        }
      ]
    };
  },
  data() {
    return {
      search: ""
    };
  },
  computed: {
    // filteredGay() {
    //   return gayArray
    //     .filter(x => {
    //       return x.actor
    //         .toLowerCase()
    //         .includes(this.search.trim().toLowerCase());
    //     })
    //     .slice(0, 10);
    // },
    // filteredNaked() {
    //   return nakedArray
    //     .filter(x => {
    //       return x.actor
    //         .toLowerCase()
    //         .includes(this.search.trim().toLowerCase());
    //     })
    //     .slice(0, 10);
    // },
    filteredActors() {
      return allActors
        .filter(x => {
          return x.actor
            .toLowerCase()
            .includes(this.search.trim().toLowerCase());
        })
        .slice(0, 10);
    }
  },
  methods: {
    scrollTop() {
      window.scrollTo(0, 0);
    },
    tracking() {
      this.$ga.page("/movies/");
    }
  },
  created() {
    this.scrollTop();
    this.tracking();
    //console.log("route " + this.$route.name);
  },
  watch: {
    $route() {
      this.tracking();
    }
  }
};
</script>